import { Tooltip } from 'antd';
import { Box } from '@mui/material';

const DefaultScreenIcon = ({ color }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width="18"
		height="18"
		color="currentColor"
		fill="none"
		stroke={color}
		strokeWidth="1.5"
	>
		<path d="M13.5049 4.47876V10.496H19.5229" />
		<path d="M10.4956 19.5223V13.5051H4.47754" />
		<path d="M9.96867 14.0315L2.99902 21" />
		<path d="M21.0009 3.00049L14.0313 9.96897" />
	</svg>
);

const FullScreenIcon = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path d="M10 2H14V6" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6 14H2V10" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M14.0007 2L9.33398 6.66667" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M2 13.9987L6.66667 9.33203" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const ScreenMenu = ({ screenSize, setScreenSize, iconColor = '#fff' }) => {
	const isFullScreen = screenSize === 'full';
	const nextScreenSize = isFullScreen ? 'md' : 'full';
	const tooltipTitle = isFullScreen ? 'Default Screen' : 'Full Screen';
	const currentIconColor = isFullScreen ? '#155DFC' : iconColor;

	return (
		<Box sx={{ display: 'flex', alignItems: 'center' }}>
			<Tooltip title={tooltipTitle}>
				<Box
					onClick={() => setScreenSize(nextScreenSize)}
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						cursor: 'pointer',
					}}
				>
					{isFullScreen ? <DefaultScreenIcon color={currentIconColor} /> : <FullScreenIcon color={currentIconColor} />}
				</Box>
			</Tooltip>
		</Box>
	);
};

export default ScreenMenu;
